import OurPartners from "../components/landingPage/OurPartners";
import OurProject from "../components/landingPage/OurProject";
import OurServices from "../components/landingPage/OurServices";
import OurStats from "../components/landingPage/OurStats";
import Testimonials from "../components/landingPage/Testimonials";
import Welcoming from "../components/landingPage/Welcoming";
import { Container } from "react-bootstrap";
import { getDataWelcoming } from "../helpers/fetchDataWelcoming";
import { getDataProjects } from "../helpers/fetchDataProject";
import { getDataStats } from "../helpers/fetchDataStats";
import { getDataPartners } from "../helpers/fetchDataPartner";
import { getDataServices } from "../helpers/fetchDataServices";
import { getDataTestimonials } from "../helpers/fetchDataTestimonials";
import { useEffect, useState } from "react";

const LandingPage = ({ moveTo, handleClose, handleShow }) => {

  const [dataContent, setDataContent] = useState(null);

  useEffect(() => {
    const initFetch = async () => {
      handleShow();
      try {
        const dataWelcoming = await getLastData(await getDataWelcoming());
        const dataProjects = await getDataProjects();
        const dataStats = await getDataStats();
        const dataPartners = await getDataPartners();
        const dataServices = await getDataServices();
        const dataTestimonials = await getLastData(await getDataTestimonials());

        setDataContent({
          dataWelcoming,
          dataProjects,
          dataStats,
          dataPartners,
          dataServices,
          dataTestimonials,
        });
        setTimeout(() => {
          handleClose();
        },500)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getLastData = (data) => {
      const lastData = data[data.length - 1];
      return lastData || null;
    };

    window.scrollTo(0, 0);

    if (!dataContent) {
      initFetch();
    }
  }, [dataContent, handleClose, handleShow]);

  return (
    <>
      <div className="landing-page d-flex flex-column align-items-center justify-content-center">
        {dataContent && (
          <>
            <div ref={moveTo[0]} style={{ padding: 0 }}>
              <Welcoming data={dataContent.dataWelcoming} />
            </div>
            <div ref={moveTo[1]} style={{ padding: 0 }}>
              <OurProject data={dataContent.dataProjects} />
            </div>
            <OurStats data={dataContent.dataStats} />
            <OurPartners data={dataContent.dataPartners} />
            <div className="our-service w-100 py-5 px-0 m-0" ref={moveTo[2]}>
              <Container className="d-flex justify-content-center align-items-center">
                <OurServices data={dataContent.dataServices} />
              </Container>
            </div>
            <Testimonials data={dataContent.dataTestimonials} />
          </>
        )}
      </div>
    </>
  );
};

export default LandingPage;
